import { useEffect, useState } from "react";
import { subscribeQueue } from "@/lib/offlineQueue";

export function useOfflineStatus() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  useEffect(() => {
    const unsub = subscribeQueue((n) => setPending(n));
    return () => unsub();
  }, []);

  return { online, pending };
}
